import { createFileRoute } from '@tanstack/react-router'

import { WorkflowsPage } from '#/modules/ai/back-office/workflows-page/workflows-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai/workflows/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['systemPrompt.read']),
  component: function Component() {
    return <WorkflowsPage />
  },
})
